const baseUrl = 'https://peixun.safety365.com.cn'   // 生产
// const baseUrl = 'https://applet.safety365.com.cn:8081'  //  测试
const config = {
  APP: {
    APP_KEY: 'HlcEv0LrYp',
    APP_SECRET: 'uyVtqWps7kUBSvLrNev6eBPxRTP5f8S6',
    RSA_PUBLICKEY: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2KuMqz7EvZJFr89TXuFVsx5O3/lpOUv/oHaPRH0+JPkJIVPIQxOYQVUNzBPprq3M/mLklbWxGKZbY6FBI+Qrn8cmqRmKqxWbPLVOZR8d+Cv7OzSJV+gBVPrPKzWhBeAn4TB0Aik0T5uKD3sPSe7tGqxGD6OoSQYs0PEoSHaBGFPIufQNIAJ4PWhnLehzq5WwPtETKFaMnrqGcR75VzHNaJxcSWomtATnWH9pmgOfqHSd7Wk59lz3ywVRaplG1t4FTfsZXt7jw9X8KGBp4ZbS9u1emxeCpFZHRYMJaaGmXC48cbLJCN9+xyyhW3R7xWIPmkjcG/7R5p08wAPrufhFOQIDAQAB'
  },
  wssaddress: 'video.safety365.com.cn:3078',
  qrCodePath: 'https://peixun.zrs365.cn/index.php?app=classroomwb&mod=MbshowCom&act=kc_scanrz_x1',
  connectPath: baseUrl,
  postPhotoPath: baseUrl + '/online-training/common/uploadSFFile', // 上传照片
  postIdCardPath: baseUrl + "/online-training/common/fileUpsfz_byother1", // 上传身份证
  fileUpbypostfilekj: baseUrl + "/online-training/common/fileUpbypostfilekj", // 上传课件
  fileUpbypostfile: baseUrl + "/online-training/common/fileUpbypostfile", // 上传证书
  fileUpbypostAliyun: baseUrl + "/online-training/common/fileUpbypostAliyun", // 文件上传至阿里云
  Api_Path_Des:'畅写回调域名',
	Api_PathSCKey:'SUNZRSVERSION1PX',
  Blank_Word_Path:"https://safety365.oss-cn-beijing.aliyuncs.com/upload/bzhkong_file266952254282346596.docx",
	// Blank_Word_Path:"https://cesshanghai.oss-cn-shanghai.aliyuncs.com/shigubiao.docx", 
  Blank_Word_Fill_Name:"bzhkong_file266952254282346596.docx",
	Blank_Word_Path_Des:"Blank_Word_Path 为office编辑空白文档",
  Api_Path:'https://peixun.zrs365.cn',
  Local_Api_Path: 'http://192.168.14.31:8998'
}
export default config
